export default __webpack_public_path__ + "locales/ru/FilesSettings.json?hash=8dfa25e672d65669f2bc17d7156fdd1c";